import { render, staticRenderFns } from "./UtxoSummary.vue?vue&type=template&id=1520a2ab&scoped=true&"
import script from "./UtxoSummary.vue?vue&type=script&lang=ts&"
export * from "./UtxoSummary.vue?vue&type=script&lang=ts&"
import style0 from "./UtxoSummary.vue?vue&type=style&index=0&id=1520a2ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520a2ab",
  null
  
)

export default component.exports